import {
  Box,
  Table,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
  TablePagination,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../common/styles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import TableSkeleton from "../common/TableSkeleton";
import SpecialityAddModal from "./speciality-add-model";
import { useState } from "react";
import AppModal from "../common/AppModal";
import ToolbarButton from "../common/Toolbar-button";
import AppSnackbar from "../common/AppSnackbar";
import SpecialityEditModal from "./speciality-edit-modal";
import EditIcon from "../../assets/icon/edit.svg";
import Delete from "../../assets/icon/delete.svg";
import { deletespeciality } from "../../features/speciality/specialitySlice";

import CustomIcon from "../common/CustomIcon";
function SpecialityScreen(props: any) {
  const { specialities, isLoading }: any = useAppSelector(
    (state) => state.speciality
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const dispatch = useAppDispatch();
  const [filteredSpecialities, setFilteredSpecialities] = useState(
    specialities?.data
  );
  const [openModal, setOpenModal] = useState(false);
  const [openModals, setOpenModals] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleCloseModals = () => setOpenModals(false);
  const skeletonArray = Array(10).fill("");
  const handleEditOpenModal = () => setOpenModals(true);
  const [specialityItem, setSpecialityItem] = useState({});

  const handleDelete = (spec_id: string) => {
    const obj = {
      spec_id: spec_id,
    };

    dispatch(deletespeciality(obj)).then((res) => {
      if (res.payload.success === true) {
        props.getSpecialities();
        setOpenModal(true);
      }
    });
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filterSpecialities = (value: any) => {
    const res = specialities?.data?.filter((spec: any) =>
      Object.values(spec)
        .join(" ")
        .toLocaleLowerCase()
        .includes(value.toLocaleLowerCase())
    );
    setFilteredSpecialities(res);
  };

  const filterSpecName = (name: any) => {
    const res = specialities?.data.filter((spec: any) => {
      const lower_case_name = spec.name.toLocaleLowerCase();
      return lower_case_name.includes(name.toLocaleLowerCase());
    });

    setFilteredSpecialities(res);
  };

  const filterSpecCountry = (count: any) => {
    const res = specialities?.data.filter((spec: any) => {
      const lower_case_count = spec.count.toLocaleLowerCase();
      return lower_case_count.includes(count.toLocaleLowerCase());
    });

    setFilteredSpecialities(res);
  };
  function Filter(field: string, value: string) {
    switch (field) {
      case "Name":
        filterSpecName(value);
        break;
      case "count":
        filterSpecCountry(value);
        break;
      default:
        return filterSpecialities(value);
    }
  }
  return (
    <TableContainer>
      <Box sx={{ mb: 4 }}>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            py: 2,
            mt: -8,
          }}
        >
          <ToolbarButton title="Add Row" 
          handleOpenModal={handleOpenModal}
           />
          <AppModal
            title="Add Row"
            open={openModal}
            handleClose={handleCloseModal}
            fullScreen={false}
          >
            <SpecialityAddModal
              handleClose={handleCloseModal}
              setOpenSnackbar={() => setOpenSnackbar(true)}
              getSpecialities={props.getSpecialities}
            />
          </AppModal>
        </Box>
      </Box>

      <Box sx={{ minWidth: 1050 }}>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Id</StyledTableCell>
              <StyledTableCell>Registered Doctors</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Description</StyledTableCell>
              <StyledTableCell>Actions</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {isLoading &&
              skeletonArray.map((_, index) => (
                <TableSkeleton key={index} cells={5} />
              ))}
            {filteredSpecialities
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

              .map((speciality: any) => (
                <StyledTableRow hover key={speciality.id}>
                  <StyledTableCell>{speciality.id}</StyledTableCell>
                  <StyledTableCell>
                    <Box
                      sx={{
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Typography color="textPrimary" variant="body1">
                        {speciality.count}
                      </Typography>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>{speciality.name}</StyledTableCell>

                  <StyledTableCell>{speciality.description}</StyledTableCell>

                  <StyledTableCell>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CustomIcon
                        style={{
                          cursor: "pointer",
                        }}
                        IconType={EditIcon}
                        title="Edit"
                        onClick={() => {
                          setSpecialityItem(speciality);
                          handleEditOpenModal();
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        marginLeft: "50px",
                        marginTop: "-30px",
                      }}
                    >
                      <CustomIcon
                        style={{
                          cursor: "pointer",
                        }}
                        IconType={Delete}
                        title="Delete"
                        onClick={() => {
                          alert("Are you sure you Want To Delete?");
                          handleDelete(speciality.id);
                        }}
                      />{" "}
                    </Box>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </Box>

      <AppModal
        title="Edit Row"
        open={openModals}
        handleClose={handleCloseModals}
        fullScreen={false}
      >
        <SpecialityEditModal
          handleEdit={handleEditOpenModal}
          speciality={specialityItem}
          dto={specialityItem}
          getSpeciality={props.getSpecialities}
          setOpenEditSnackbar={() => setOpenModals(true)}
        />
      </AppModal>
      <AppSnackbar
        message="Success!"
        open={openSnackbar}
        handleClose={() => setOpenModals(false)}
      />

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
        colSpan={3}
        count={specialities?.data?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          native: true,
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}
export default SpecialityScreen;
